import swal from "sweetalert";
import axiosInstance from "../api";
import {setGetWishFilter,setgetWishList,setGetSingleBookingdata,setUsersList, seGetAddress,setGetDriversList, setGetBookingList, setGetDashboard, setGetRatingList, setGetCategoresList,setGetOffersList, setGetBookingListOfData, setHeaderCount } from "./bookingSlice";
import { setWishList,setSingleBookingss } from "../../reusableSlice";
export const getAllBookings = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/orders/", { params: data });
      if (response?.data?.status) {
        dispatch(setGetBookingList(response?.data?.response))
      } else {
        dispatch(setGetBookingList([]))
      }
    } catch (err) {
      // console.error(err);
      dispatch(setGetBookingList([]))
    }
  };

  export const getAllDashBoardData = () => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/dashboard/");
      if (response?.data?.status) {
        dispatch(setGetDashboard(response?.data?.response))
      } else {
        dispatch(setGetDashboard([]))
      }
    } catch (err) {
      // console.error(err);
      dispatch(setGetDashboard([]))
    }
  };

  export const getAllHeaderCount = () => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/dashboard/counts");
      if (response?.data?.status) {
        dispatch(setHeaderCount(response?.data?.response))
        console.log(response?.data?.response ,  "response:")
      } else { 
        dispatch(setHeaderCount([]))
      }
    } catch (err) {
      // console.error(err);
      dispatch(setHeaderCount([]))
    }
  };


  export const getAllAddress = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/customers/addresses", { params: data });
      if (response?.data?.status) {
        dispatch(seGetAddress(response?.data?.response))
      } else {
        dispatch(seGetAddress([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(seGetAddress([]))
    }
  };

  export const getAllRatingsList = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/reviews/", { params: data });
      if (response?.data?.status) {
        dispatch(setGetRatingList(response?.data?.response))
      } else {
        dispatch(setGetRatingList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setGetRatingList([]))
    }
  };

  export const wishListData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/wishlists/", { params: data });
      if (response?.data?.status) {
        dispatch(setgetWishList(response?.data?.response))
      } else {
        dispatch(setgetWishList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setgetWishList([]))
    }
  };

  export const wishlistFilter = (country_code,mobile_number) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/customers/search", {
        params: { country_code, mobile_number }
      });
      if (response?.data?.status) {
        dispatch(setGetWishFilter(response?.data?.response))
      } else {
        dispatch(setGetWishFilter([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setGetWishFilter([]))
    }
  };

  export const getAllWishList = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/wishlists/", { params: data });
      if (response?.data?.status) {
        dispatch(setWishList(response?.data?.response))
        console.log(response?.data?.response,"response?.data?.response")
      } else {
        dispatch(setWishList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setWishList([]))
    }
  };

  export const getAllCategories = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/categories/", { params: data });
      console.log(response,"sdsdsdsaadsa")
      if (response?.data?.status) {
        dispatch(setGetCategoresList(response?.data?.response))
      } else {
        dispatch(setGetCategoresList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setGetCategoresList([]))
    }
  };

  export const getAllOffers= (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/offers/", { params: data });
      if (response?.data?.status) {
        dispatch(setGetOffersList(response?.data?.response))
      } else {
        dispatch(setGetOffersList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setGetOffersList([]))
    }
  };

  export const getAllDrivers= (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/drivers/", { params: data });
      if (response?.data?.status) {
        dispatch(setGetDriversList(response?.data?.response))
      } else {
        dispatch(setGetDriversList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setGetDriversList([]))
    }
  };

  export const getAllListUsers= (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/customers/", { params: data });
      if (response?.data?.status) {
        dispatch(setUsersList(response?.data?.response))
      } else {
        dispatch(setUsersList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setUsersList([]))
    }
  };


  export const getSingleBookingData= (data) => async (dispatch) => {
    try {
      const orderId = data?.id || data?.order_id;
      const response = await axiosInstance.get(`admin/orders/${orderId}`, { params: data });
      if (response?.data?.status) {
        dispatch(setGetSingleBookingdata(response?.data?.response))
      } else {
        dispatch(setGetSingleBookingdata([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setGetSingleBookingdata([]))
    }
  };


  export const getCompleteBookings = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/orders/", { params: data });
      if (response?.data?.status) {
        dispatch(setGetBookingListOfData(response?.data?.response))
      } else {
        dispatch(setGetBookingListOfData([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setGetBookingListOfData([]))
    }
  };

  export const getSingleBooking = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/orders/${id}`);
      console.log(response,"responsesdfssfs")
      if (response?.data) {
        dispatch(setSingleBookingss(response?.data?.response))
      } else {
        dispatch(setSingleBookingss([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setSingleBookingss([]))
    }
  };